<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="头像">
            <upload-image
              @uploadChange="uploadChange"
              :imageInit="imageUrl"
              :imageCount="0"
              :showUploadList="false"
              @cancelFile="cancelFile"
              :multiple="false"
              :fileListInit="[]"
            ></upload-image>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="密码">
            <a-input
              v-model="data.password"
              placeholder="请输入密码(如果需要修改密码)"
              type='password'
              v-decorator="[
              'password',
              {rules: [{ required: false, message: '请输入密码' }]}]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row class="form-row" v-if="data.password">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="确认密码">
            <a-input
              v-model="data.password1"
              placeholder="请输入确认密码"
              type='password'
              v-decorator="[
              'password1',
              {rules: [{ required: false, message: '请输入确认密码' },{
            validator: compareToFirstPassword,
              }]}]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col class="form-row"></a-col>
      </a-row>

      <div class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  avatar: "",
  password: "",
  password1:""
};
export default {
  name: "hp-manager-page-user-info-modify",
  mixins: [account, dateFormat],
  data() {
    return {
      loading: false,
      data: {},
      imageUrl: '',
      listType: "text",
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };
  },
  mounted() {
        this.imageUrl=this.userData.avatar
       this.data = exzends(defaultData);
       this.data.id=this.userData.userId
       this.data.avatar=this.userData.avatar
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    compareToFirstPassword  (rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue('password')) {
        callback('两次密码不一致');
      } else {
        callback();
      }
    },
    uploadChange(fileList) {
      this.imageUrl = fileList[0].url;
    },
    cancelFile(fileList) {
      this.imageUrl = fileList[0].url;
    },
    
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        password: value.password,
        avatar: this.imageUrl
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        console.log(requestData)
        let data = await api.UserSet(requestData);
        if (data) {
           this.$message.success("修改成功");
           this.$emit("cancel");
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/output.scss";
</style>


// WEBPACK FOOTER //
// src/components/navigation/userSetting.vue